'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var reactRouterDom = require('react-router-dom');
var styled = require('styled-components');
var components_SvgIcon_index = require('../SvgIcon/index.js');
var components_Title1_index = require('../Title1/index.js');
var constants_properties = require('../../constants/properties.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var LinkText = styled__default["default"](components_Title1_index["default"])(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  padding: 16px ", ";\n  display: inline-block;\n\n  ", "\n"], ["\n  padding: 16px ", ";\n  display: inline-block;\n\n  ", "\n"])), function (_a) {
    var asWide = _a.asWide;
    return (asWide ? '20px' : '10px');
}, function (_a) {
    var withIcon = _a.withIcon;
    return withIcon
        ? "\n        &&& {\n          align-items: center;\n          display: flex;\n          gap: 16px;\n        }\n      "
        : '';
});
var Underline = styled__default["default"].div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  border-radius: 7px;\n  width: 100%;\n  background-color: ", ";\n  height: 3px;\n"], ["\n  border-radius: 7px;\n  width: 100%;\n  background-color: ", ";\n  height: 3px;\n"])), function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
});
var sharedStyles = styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: inline-block;\n\n  ", " {\n    visibility: hidden;\n  }\n\n  ", " {\n    color: ", ";\n  }\n\n  :hover {\n    ", " {\n      color: ", ";\n    }\n  }\n\n  &.is-active {\n    ", " {\n      visibility: visible;\n    }\n\n    ", " {\n      color: ", ";\n    }\n  }\n"], ["\n  display: inline-block;\n\n  ", " {\n    visibility: hidden;\n  }\n\n  ", " {\n    color: ", ";\n  }\n\n  :hover {\n    ", " {\n      color: ", ";\n    }\n  }\n\n  &.is-active {\n    ", " {\n      visibility: visible;\n    }\n\n    ", " {\n      color: ", ";\n    }\n  }\n"])), Underline, LinkText, function (_a) {
    var secondary = _a.theme.colors.text.secondary;
    return secondary;
}, LinkText, function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
}, Underline, LinkText, function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
});
var NavigationLink = styled__default["default"](reactRouterDom.NavLink).attrs({ end: true })(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), sharedStyles);
var NonNavButton = styled__default["default"].div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  ", "\n  cursor: pointer;\n"], ["\n  ", "\n  cursor: pointer;\n"])), sharedStyles);
var TabItem = function (_a) {
    var active = _a.active, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, to = _a.to, startIcon = _a.startIcon, _c = _a.wide, wide = _c === void 0 ? false : _c, onClick = _a.onClick;
    var Content = React.useMemo(function () { return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(LinkText, { asWide: wide, withIcon: Boolean(startIcon) },
            startIcon && (React__default["default"].createElement(components_SvgIcon_index["default"], { icon: startIcon, fill: active ? constants_properties.SvgIconColor.PRIMARY : constants_properties.SvgIconColor.SECONDARY, size: constants_properties.SvgIconSize.MEDIUM })),
            children),
        React__default["default"].createElement(Underline, null))); }, [active, children, startIcon]);
    var classes = React.useMemo(function () { return (active ? "".concat(className, " is-active") : className); }, [className, active]);
    return to ? (React__default["default"].createElement(NavigationLink, { className: classes, to: to }, Content)) : (React__default["default"].createElement(NonNavButton, { className: classes, onClick: onClick, role: "button" }, Content));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

exports["default"] = TabItem;
